import { Box, styled } from '../../base';
import { TOP_HEADER_HEIGHT } from '../../common';

export const ContentContainer = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.background.mainBackground,
    flexGrow: '1',
    height: `calc(100vh - ${TOP_HEADER_HEIGHT}px)`,
}));

export const ContentBox = styled(Box)(() => ({
    flex: '1',
    overflow: 'auto',
    overflowX: 'hidden',
    height: `calc(100vh - ${TOP_HEADER_HEIGHT}px)`,
}));

export const PageLayoutWrapperBox = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
}));

export const BoxBelowTopHeader = styled(Box)(() => ({
    display: 'flex',
    flex: '1',
    overflow: 'hidden',
    height: `calc(100vh - ${TOP_HEADER_HEIGHT}px)`,
}));

export const SideMenuBox = styled(Box)(() => ({
    flexShrink: '0',
    height: `calc(100vh - ${TOP_HEADER_HEIGHT}px)`,
    position: 'sticky',
    top: '0',
}));
